import CDS from "design-system";
import { NewHireJourney } from "models/v2/newHireJourney";
import {
  newHireJourneyStageInfo,
  findNextMilestoneDayNumber,
} from "features/Stage/helpers";
import { ALL_STAGES_MINUS_IMMEDIATE_DEPENDENCY } from "features/Stage/constants";
import { getJourneyDayNumber } from "features/NewHireJourney/helpers";
import HeaderStatCard from "./HeaderStatCard";

interface HeaderStageCardProps {
  newHireJourney: NewHireJourney;
}

const STAGE_KEYS = ALL_STAGES_MINUS_IMMEDIATE_DEPENDENCY.map((s) => s.key);

export default function HeaderStageCard({ newHireJourney }: HeaderStageCardProps) {
  const { key, label } = newHireJourneyStageInfo(newHireJourney);
  // day1 isn't a distinct row in the timeline (see StageBadge + StageTag popover) —
  // fold it into week1 so the index matches what the popover shows.
  const lookupKey = key === "day1" ? "week1" : key;
  const currentIndex = STAGE_KEYS.findIndex((k) => k === lookupKey);

  const journeyDay = getJourneyDayNumber(newHireJourney.startDate, newHireJourney.newHire?.timezone);
  const milestoneDay = currentIndex >= 0
    ? findNextMilestoneDayNumber(newHireJourney, STAGE_KEYS, currentIndex)
    : null;

  const textureParts: string[] = [];
  if (journeyDay != null) textureParts.push(`Day ${journeyDay}`);
  if (milestoneDay != null) textureParts.push(`Next milestone: Day ${milestoneDay}`);
  const texture = textureParts.length ? textureParts.join(" · ") : undefined;

  return (
    <HeaderStatCard
      eyebrow="Stage"
      hero={
        <CDS.Text16 fontWeight="600" color="content.primary">
          {label}
        </CDS.Text16>
      }
      texture={texture}
      flex="1.1"
      minW="220px"
    />
  );
}
